import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import * as DoorAccessActionCreators from '../../../actions/doorAccess'
import Pluralize from '../../controls/Pluralize'
import DeleteUsersButton from './DeleteUsersButton'

class DeleteUsersButtonContainer extends React.Component {
  static propTypes = {
    /* passed props */
    accessIds: PropTypes.array.isRequired,
    communityId: PropTypes.number.isRequired,
    onDeleteComplete: PropTypes.func,
    tooltipTitle: PropTypes.node,
    /* mapped state */
    doorAccesses: PropTypes.object.isRequired,
    /* mapped dispatch */
    doorAccessActions: PropTypes.object.isRequired,
  }

  static defaultProps = {
    onDeleteComplete: () => {},
    tooltipTitle: null,
  }

  static mapStateToProps(state) {
    return {
      doorAccesses: state.doorAccesses,
    }
  }

  static mapDispatchToProps(dispatch) {
    return {
      doorAccessActions: bindActionCreators(DoorAccessActionCreators, dispatch),
    }
  }

  getConfirmationText = () => {
    const { accessIds, doorAccesses } = this.props
    let confirmationText = 'Are you sure you want to delete the selected user(s)?'

    if (accessIds.length === 1) {
      const name = doorAccesses[accessIds[0]].name || 'the selected user'
      confirmationText = `Are you sure you want to delete ${name}?`
    } else {
      confirmationText = `Are you sure you want to delete the ${accessIds.length} selected users?`
    }

    return confirmationText
  }

  handleDelete = () => {
    this.props.doorAccessActions.removeDoorAccesses(this.props.communityId, this.props.accessIds)
    this.props.onDeleteComplete()
  }

  render() {
    const userCount = this.props.accessIds.length
    const tooltipTitle = this.props.tooltipTitle || (
      <span>
        Delete <Pluralize count={userCount} showCount={userCount > 1} singular="User" />
      </span>
    )

    return (
      <DeleteUsersButton
        confirmationText={this.getConfirmationText()}
        onDelete={this.handleDelete}
        tooltipTitle={tooltipTitle}
      />
    )
  }
}

export default connect(
  DeleteUsersButtonContainer.mapStateToProps,
  DeleteUsersButtonContainer.mapDispatchToProps,
)(DeleteUsersButtonContainer)
